import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Calendar,
  Coffee,
  Colorfilter,
  Heart,
  People,
  Pet,
  Teacher,
  User,
} from "iconsax-react";

import MobileLayout from "../../../components/MobileLayout";
import {
  DICTIONARY_CATEGORIES,
  type DictionaryCategoryId,
} from "../../../services/dictionaryCategories";

import {
  Body,
  CategoryCard,
  CategoryGrid,
  CategoryHint,
  CategoryIconBox,
  CategoryTitle,
  IntroCard,
  IntroSubtitle,
  IntroTitle,
} from "./styles";

const CATEGORY_ICONS: Record<DictionaryCategoryId, React.ReactNode> = {
  family: <People size={22} variant="Bold" />,
  animals: <Pet size={22} variant="Bold" />,
  colors: <Colorfilter size={22} variant="Bold" />,
  food: <Coffee size={22} variant="Bold" />,
  body: <User size={22} variant="Bold" />,
  emotions: <Heart size={22} variant="Bold" />,
  time: <Calendar size={22} variant="Bold" />,
  school: <Teacher size={22} variant="Bold" />,
};

const CategorySelection: React.FC = () => {
  const navigate = useNavigate();

  const handleCategoryPress = (categoryId: DictionaryCategoryId) => {
    navigate(`/sinalario/list?category=${categoryId}`);
  };

  return (
    <MobileLayout headerTitle="Categorias" headerType="private">
      <Body>
        <IntroCard>
          <IntroTitle>Explorar por tema</IntroTitle>
          <IntroSubtitle>
            Encontre sinais por assunto — família, animais, cores e mais. Ideal
            para ampliar o vocabulário.
          </IntroSubtitle>
        </IntroCard>

        <CategoryGrid>
          {DICTIONARY_CATEGORIES.map((category) => (
            <CategoryCard
              key={category.id}
              type="button"
              $accent={category.color}
              onClick={() => handleCategoryPress(category.id)}
              aria-label={category.label}
            >
              <CategoryIconBox $accent={category.color}>
                {CATEGORY_ICONS[category.id]}
              </CategoryIconBox>
              <div>
                <CategoryTitle>{category.label}</CategoryTitle>
                <CategoryHint>Ver sinais</CategoryHint>
              </div>
            </CategoryCard>
          ))}
        </CategoryGrid>
      </Body>
    </MobileLayout>
  );
};

export default CategorySelection;
